import { LegalPageLayout } from './LegalPageLayout';

export default function AGB() {
  return (
    <LegalPageLayout title="Allgemeine Geschäftsbedingungen (AGB)" lastUpdated="Februar 2026" testId="agb-page">
      <p className="italic text-slate-500">
        Hier werden die Allgemeinen Geschäftsbedingungen eingefügt. Die folgenden Angaben sind Platzhalter und
        müssen vor dem produktiven Einsatz durch verbindliche Vertragsbedingungen ersetzt werden.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-3">§ 1 Geltungsbereich</h2>
      <p>
        Diese AGB gelten für sämtliche Verträge über die Nutzung der Immobilien-Verwaltungssoftware
        „Immo Verwalter" zwischen dem Betreiber [Firma] (im Folgenden „Anbieter") und seinen
        gewerblichen oder privaten Kunden („Nutzer").
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 2 Vertragsgegenstand</h2>
      <p>
        Der Anbieter stellt dem Nutzer die Software als Software-as-a-Service (SaaS) zur Verfügung. Der
        Funktionsumfang ergibt sich aus der jeweils aktuellen Leistungsbeschreibung auf der Website.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 3 Vertragsschluss</h2>
      <p>
        Der Vertrag kommt durch die Registrierung eines Kontos und Bestätigung dieser AGB zustande. Mit der
        Registrierung versichert der Nutzer, geschäftsfähig und volljährig zu sein.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 4 Leistungen des Anbieters</h2>
      <ul className="list-disc list-inside space-y-1 mt-2">
        <li>Bereitstellung der SaaS-Anwendung über das Internet</li>
        <li>Verschlüsselte Datenübertragung (HTTPS / TLS)</li>
        <li>Tägliche Backups</li>
        <li>Optional: KI-gestützte Beleg-Klassifizierung über IONOS AI (DSGVO-konform)</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 5 Pflichten des Nutzers</h2>
      <p>
        Der Nutzer ist verpflichtet, seine Zugangsdaten geheim zu halten und nur eigene oder solche Daten
        einzustellen, an denen er die erforderlichen Rechte besitzt. Bei Verstößen ist der Anbieter
        berechtigt, das Konto fristlos zu sperren.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 6 Verfügbarkeit &amp; Wartung</h2>
      <p>
        Der Anbieter strebt eine Verfügbarkeit von 99,5 % im Jahresmittel an. Geplante Wartungsarbeiten
        werden rechtzeitig über das im System integrierte Hinweis-Banner angekündigt.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 7 Vergütung</h2>
      <p>
        Die Nutzung kann ein nutzungsabhängiges Entgelt (z.B. für KI-Anfragen) umfassen. Aktuelle Preise
        sind in der Preisliste einsehbar und werden pro Mandant monatlich abgerechnet.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 8 Haftung</h2>
      <p>
        Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit. Bei einfacher Fahrlässigkeit
        nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vertragstypischen,
        vorhersehbaren Schaden.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 9 Kündigung</h2>
      <p>
        Das Vertragsverhältnis kann von beiden Seiten mit einer Frist von 30 Tagen zum Monatsende
        gekündigt werden. Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900 mt-6 mb-3">§ 10 Schlussbestimmungen</h2>
      <p>
        Es gilt deutsches Recht. Gerichtsstand ist – soweit gesetzlich zulässig – der Sitz des Anbieters.
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt.
      </p>

      <p className="italic text-slate-400 text-xs mt-8">
        Hinweis: Dies ist ein automatisch generierter Platzhalter. Vor produktivem Einsatz unbedingt
        anwaltlich prüfen lassen.
      </p>
    </LegalPageLayout>
  );
}
